var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 11.5125L6.38403 10.05V20.8567C6.38413 20.9741 6.40735 21.0904 6.45237 21.1988C6.49739 21.3072 6.56332 21.4057 6.64641 21.4887C6.72949 21.5716 6.8281 21.6374 6.93661 21.6822C7.04511 21.7271 7.16138 21.7501 7.27878 21.75H21.6038C21.7213 21.7503 21.8377 21.7274 21.9464 21.6827C22.0551 21.6379 22.1539 21.5722 22.2371 21.4892C22.3204 21.4062 22.3864 21.3077 22.4316 21.1991C22.4767 21.0906 22.4999 20.9743 22.5 20.8567V16.875L14.6858 11.5125Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 2.25H7.27878C7.16138 2.2499 7.04511 2.27293 6.93661 2.31776C6.8281 2.3626 6.72949 2.42837 6.64641 2.51132C6.56332 2.59426 6.49739 2.69276 6.45237 2.80119C6.40735 2.90962 6.38413 3.02585 6.38403 3.14325V7.125L14.6858 12L19.0815 13.4625L22.5 12V7.125L14.6858 2.25Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38403 7.125H14.6858V12H6.38403V7.125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3255 6.15002H6.38403V18.3375H12.3255C12.5623 18.3363 12.789 18.2419 12.9567 18.0747C13.1243 17.9075 13.2193 17.681 13.221 17.4443V7.04327C13.2193 6.80653 13.1243 6.58002 12.9567 6.41282C12.789 6.24562 12.5623 6.1512 12.3255 6.15002Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8373 6.63751H6.38403V18.825H11.8373C12.074 18.8238 12.3008 18.7294 12.4684 18.5622C12.636 18.395 12.731 18.1685 12.7328 17.9318V7.53076C12.731 7.29402 12.636 7.0675 12.4684 6.90031C12.3008 6.73311 12.074 6.63869 11.8373 6.63751Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.8373 6.63751H6.38403V17.85H11.8373C12.074 17.8488 12.3008 17.7544 12.4684 17.5872C12.636 17.42 12.731 17.1935 12.7328 16.9568V7.53076C12.731 7.29402 12.636 7.0675 12.4684 6.90031C12.3008 6.73311 12.074 6.63869 11.8373 6.63751Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.349 6.63751H6.38403V17.85H11.349C11.5858 17.8488 11.8125 17.7544 11.9802 17.5872C12.1478 17.42 12.2428 17.1935 12.2445 16.9568V7.53076C12.2428 7.29402 12.1478 7.0675 11.9802 6.90031C11.8125 6.73311 11.5858 6.63869 11.349 6.63751Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3955 6.63751H11.349C11.5862 6.63731 11.8137 6.73129 11.9816 6.89878C12.1496 7.06628 12.2441 7.29359 12.2445 7.53076V16.4693C12.2441 16.7064 12.1496 16.9337 11.9816 17.1012C11.8137 17.2687 11.5862 17.3627 11.349 17.3625H2.3955C2.27804 17.3627 2.16168 17.3398 2.05309 17.295C1.9445 17.2502 1.84581 17.1844 1.76264 17.1015C1.67948 17.0185 1.61348 16.92 1.56841 16.8115C1.52334 16.703 1.5001 16.5867 1.5 16.4693V7.53076C1.5001 7.4133 1.52334 7.297 1.56841 7.18853C1.61348 7.08005 1.67948 6.98152 1.76264 6.89856C1.84581 6.81561 1.9445 6.74985 2.05309 6.70506C2.16168 6.66027 2.27804 6.63732 2.3955 6.63751Z",
    fill: "url(#paint0_linear_113_7193)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2749 14.9048L6.15815 11.9918L4.43315 9.09528H5.8184L6.75965 10.95C6.84665 11.1255 6.90965 11.256 6.93815 11.343H6.9509C7.0124 11.202 7.07765 11.0663 7.1459 10.9335L8.1524 9.09828H9.4274L7.65815 11.9783L9.4724 14.907H8.11565L7.02815 12.8738C6.97766 12.7864 6.93475 12.6948 6.8999 12.6H6.8819C6.85019 12.6923 6.80791 12.7807 6.7559 12.8633L5.63615 14.9048H4.2749Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6045 2.25H14.6858V7.125H22.5V3.14325C22.4999 3.02579 22.4767 2.90949 22.4316 2.80102C22.3866 2.69254 22.3206 2.59401 22.2374 2.51105C22.1542 2.4281 22.0555 2.36234 21.9469 2.31755C21.8384 2.27276 21.722 2.2498 21.6045 2.25Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6858 12H22.5V16.875H14.6858V12Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_7193",
    x1: 3.3705,
    y1: 5.93551,
    x2: 10.374,
    y2: 18.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXl);
export default __webpack_public_path__ + "static/media/xl.880bfecb6f41178c9113dc25e08c1ca6.svg";
export { ForwardRef as ReactComponent };